/**
 * `EvidencePackPage` — Evidence pack export page (/workspace/audit/evidence-pack)
 *
 * Standalone page for evidence pack generation.
 */

import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EvidencePackPanel } from '@/components/audit/EvidencePackPanel';

export function EvidencePackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(true);

  const rowId = searchParams.get('row_id') || undefined;

  const handleClose = () => {
    setIsOpen(false);
    // Navigate back to audit list
    navigate('/workspace/audit');
  };

  return (
    <EvidencePackPanel
      isOpen={isOpen}
      onClose={handleClose}
      rowId={rowId}
    />
  );
}